export enum RightPanelContent {
    LayerSelector = 'layerSelect',
    None = 'none',
}
